module.exports = __webpack_public_path__ + "static/media/slott-min.4a657d42.png";